module.exports = __webpack_public_path__ + "static/office-1e2d8f499e14e438173dc455dd3ea844.jpg";